import React from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from './loader.json';

const Loader = ({ percentage }) => {
  return (
    <div className="flex flex-col justify-center items-center h-full w-full">
      <div className="w-32 h-32">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
      {percentage !== undefined && (
        <div className="text-gray-600 mt-2">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
};

export default Loader; 